import { PageContentEditAccount } from '@restaurant/core'
import { useWebEditAccountPageViewModel } from '../viewmodels/pages/WebEditAccountPageViewModel'

export default function ManageAccountPage() {
  const viewModel = useWebEditAccountPageViewModel()
  const pageProps = viewModel.getPageContentEditAccountProps()

  return (
    <PageContentEditAccount
      {...pageProps}
      testID="manage-account-page"
      accessibilityLabel="Edit your account information"
    />
  )
}
